import noPicture from '@/asset/no-picture.png';

export const getHeadPicture = (value?: string): React.ReactElement => {
  return <span>
    <img src={value || noPicture} className="feishu-head-picture" />
  </span>;
};
